import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, computed, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENVIRONMENT_SERVICE_TOKEN, IEnvironmentService } from '../environment/environment-service.interface';
import { ICompany, ICompanyService, ResponseData } from './company-service.interface';

export const COMPANY_SERVICE_TOKEN = new InjectionToken<ICompanyService>('ICompanyService');

@Injectable()
export class CompanyService implements ICompanyService {
  private url: string = this.environmentService.apiUrl;

  private _initCompanySig = toSignal(
    this.http.get(`${this.url}/account/company`).pipe(
      map((response: ResponseData) => {
        return response.data;
      }),
      catchError((error) => {
        if (error.status === 403) {
          const defaultCompany: ICompany = <ICompany>{
            id: 0,
            active: false,
            country: '**',
          };

          return of(defaultCompany);
        } else {
          throw error;
        }
      })
    )
  );

  private _companySig = signal<Partial<ICompany> | null>(null);

  public companySig = computed<ICompany | null>(() => {
    if (!this._initCompanySig() && !this._companySig()) {
      return null;
    }

    return {
      ...this._initCompanySig(),
      ...this._companySig(),
    };
  });

  constructor(
    @Inject(ENVIRONMENT_SERVICE_TOKEN) private environmentService: IEnvironmentService,
    private http: HttpClient
  ) {}

  updateCompany(company: Partial<ICompany>) {
    this._companySig.set(company);
  }
}
